import React from 'react';
import { Box } from '@material-ui/core';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import OutlinedButton from '../../../shared/Buttons/OutlinedButton';
import FilledButton from '../../../shared/Buttons/FilledButton';

const styles = {
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    width: '100%',
    gap: '16px',
  },
};

interface AddRoleActionButtonsProps
  extends RouteComponentProps,
    WithStyles<typeof styles> {
  handleSubmit: () => void;
}

const AddRoleActionButtons: React.FC<AddRoleActionButtonsProps> = (props) => {
  const { classes, history, handleSubmit } = props;
  const handleCancelClick = () => {
    history.push('/roles');
  };

  return (
    <Box className={classes.buttonsContainer}>
      <OutlinedButton text="Cancel" handleClick={handleCancelClick} />
      <FilledButton text="Save Changes" handleClick={handleSubmit} />
    </Box>
  );
};

export default withRouter(
  withStyles(styles as any, { withTheme: true })(AddRoleActionButtons),
);
